import React from 'react';

// Critical components that should load immediately (keep synchronous)
import AuthenticatedLandingPage from "../views/AuthenticatedLandingPage";
import Dashboard from "../views/Dashboard";
import NotImplementedYet from '../views/NotImplementedYet';

// Lazy load all other components for code splitting
const ContactCards = React.lazy(() => import("../views/Contact/ContactCards"));
const ContactList = React.lazy(() => import("../views/Contact/ContactList"));
const EditContact = React.lazy(() => import("../views/Contact/EditContact"));

const AddNewProductInput = React.lazy(() => import("../views/ProductInput/AddNewProductInput"));
const EditProductInput = React.lazy(() => import("../views/ProductInput/EditProductInput"));
const ProductInputList = React.lazy(() => import("../views/ProductInput/ProductInputList"));
const CreateProductInput = React.lazy(() => import("../views/ProductInput/CreateProductInput"));
const ProductInputDetail = React.lazy(() => import("../views/ProductInput/ProductInputDetail"));

const OpportunitySearchLandingPage = React.lazy(() => import("../views/Opportunity/OpportunitySearchLandingPage"));
const RecentOpportunitySearchList = React.lazy(() => import("../views/Opportunity/RecentOpportunitySearchList"));
const SavedOpportunitySearchListFORM = React.lazy(() => import("../views/Opportunity/SavedOpportunitySearchListFORM"));
const ProjectsListGrid = React.lazy(() => import("../views/Opportunity/ProjectsListGrid"));
const ProjectsListCards = React.lazy(() => import("../views/Opportunity/ProjectsListCards"));

const ProjectDetails = React.lazy(() => import("../views/Project/"));
const SourcingProjectDetails = React.lazy(() => import("../views/Project/SourcingProjectDetails"));
const CreateSourcingProject = React.lazy(() => import("../views/Project/CreateSourcingProject"));
const SuppliersLandingPage = React.lazy(() => import("../views/Suppliers/Index"));
const SuppliersSearch = React.lazy(() => import("../views/Suppliers/Search"));
const SavedSupplierSearchList = React.lazy(() => import("../views/Suppliers/SavedSupplierSearchList"));
const MySuppliersList = React.lazy(() => import("../views/Suppliers/MySuppliersList"));
const SupplierProfile = React.lazy(() => import("../views/Suppliers/Profile/SupplierProfile"));
const SupplierDetails = React.lazy(() => import("../views/Suppliers/SupplierDetails"));
const CreateSupplier = React.lazy(() => import("../views/Suppliers/CreateSupplier"));

// FILEMANAGER module
const GridView = React.lazy(() => import("../views/FileManager/GridView"));
const ListView = React.lazy(() => import("../views/FileManager/ListView"));

//Pages
const Profile = React.lazy(() => import("../views/Profiles/Profile"));
const EditProfile = React.lazy(() => import("../views/Profiles/EditProfile"));
const Account = React.lazy(() => import("../views/Profiles/Account"));
const CompanyAccount = React.lazy(() => import("../views/Profiles/CompanyAccount"));

//Auth
const Login = React.lazy(() => import("../views/Authentication/LogIn/Login/Login"));
const LoginSimple = React.lazy(() => import("../views/Authentication/LogIn/LoginSimple"));
const LoginClassic = React.lazy(() => import("../views/Authentication/LogIn/LoginClassic"));
const Signup = React.lazy(() => import("../views/Authentication/SignUp/Signup"));
const SignUpSimple = React.lazy(() => import("../views/Authentication/SignUp/SignupSimple"));
const SignupClassic = React.lazy(() => import("../views/Authentication/SignUp/SignupClassic"));
const LockScreen = React.lazy(() => import("../views/Authentication/LockScreen"));
const ResetPassword = React.lazy(() => import("../views/Authentication/ResetPassword"));

const Error404 = React.lazy(() => import("../views/Authentication/Error404/Error404"));
const Error503 = React.lazy(() => import("../views/Authentication/Error503/Error503"));
const ErrorMethodNotAllowed = React.lazy(() => import("../views/error/ErrorMethodNotAllowed"));
const ErrorConflict = React.lazy(() => import("../views/error/ErrorConflict"));
const ErrorExpectationFailed = React.lazy(() => import("../views/error/ErrorExpectationFailed"));
const ErrorUnprocessableEntity = React.lazy(() => import("../views/error/ErrorUnprocessableEntity"));
const ErrorServerError = React.lazy(() => import("../views/error/ErrorServerError"));
const ErrorForbidden = React.lazy(() => import("../views/error/ErrorForbidden"));
const ErrorUnauthorized = React.lazy(() => import("../views/error/ErrorUnauthorized"));
const ErrorNoAccessToken = React.lazy(() => import("../views/error/ErrorNoAccessToken"));
const ErrorAccountNotConfigured = React.lazy(() => import("../views/ErrorAccountNotConfigured"));

//STATUS and TESTING pages
const TestView = React.lazy(() => import("../views/TestView"));
const health = React.lazy(() => import("../views/health"));
const TestIcons = React.lazy(() => import('../components/telescope/TestIcons.jsx')); 
const SourcingProjectsPage = React.lazy(() => import('../components/telescope/SourcingProjectsPage.jsx')); 
const GeolocationExample = React.lazy(() => import('../components/telescope/GeolocationExample.jsx'));
const MapLeafletExamplePage = React.lazy(() => import('../views/Test/MapLeafletExamplePage.jsx'));
const SupplierScore = React.lazy(() => import('../views/Test/SupplierScore.jsx')); 
const ApiEndpointTest = React.lazy(() => import('../views/Test/ApiEndpointTest.jsx')); 
const SupplierToItemTest = React.lazy(() => import('../views/Test/SupplierToItemTest.jsx')); 
const SupplierRequirementsTest = React.lazy(() => import('../views/Test/SupplierRequirementsTest.jsx'));
const DocumentTestView = React.lazy(() => import("../views/DocumentTestView"));

export const routes = [

    // LANDING PAGE -> AUTHENTICATED users
    { path: 'dashboard', exact: true, component: Dashboard },

    // Apps from TEMPLATE
    { path: 'apps/contacts/contact-list', exact: true, component: ContactList },

    // productinput
    { path: 'productinputs', exact: true, component: ProductInputList },
    { path: 'productinputs/list', exact: true, component: ProductInputList },   
    { path: 'productinput/:id', exact: true, component: ProductInputDetail },
    { path: 'productinput/edit/:id', exact: true, component: EditProductInput },   
    { path: 'productinputs/edit/:id', exact: true, component: EditProductInput },   
    { path: 'productinput/new', exact: true, component: AddNewProductInput },
    // { path: 'productinput/create', exact: true, component: CreateProductInput },
    // { path: 'productinput/create/project/:id', exact: true, component: CreateProductInput },
    { path: 'project/:projectid/productinput/create', exact: true, component: CreateProductInput },
    
    // OPPORTUNITIES
    { path: 'opportunities/:reset?', exact: true, component: OpportunitySearchLandingPage },
    { path: 'opportunities/search', exact: true, component: OpportunitySearchLandingPage },
    { path: 'opportunities/savedsearches', exact: true, component: SavedOpportunitySearchListFORM },

    { path: 'projects/opportunities/cards', exact: true, component: ProjectsListCards },
    { path: 'projects/opportunities/listview', exact: true, component: ProjectsListGrid },

    { path: 'project/opportunity/:id', exact: true, component: ProjectDetails },
    { path: 'project/sourcing/:id', exact: true, component: SourcingProjectDetails },
    { path: 'project/:id', exact: true, component: SourcingProjectDetails },

    // SOURCNG PROJECTS
    { path: 'sourcing/projects/cards', exact: true, component: ProjectsListCards },
    { path: 'projects/sourcing/create', exact: true, component: CreateSourcingProject },
    // { path: 'projects/sourcing/cards', exact: true, component: ProjectsListCards },
    { path: 'projects/sourcing/detail', exact: true, component: SourcingProjectsPage },
    { path: 'projects/sourcing/listview', exact: true, component: ProjectsListGrid },
    
    { path: 'projects/sourcing', exact: true, component: SourcingProjectsPage },

    { path: '/', exact: true, component: AuthenticatedLandingPage },
    { path: 'landing', exact: true, component: AuthenticatedLandingPage },
    { path: '/protected', exact: true, component: AuthenticatedLandingPage },

    // SUPPLIERS
    { path: 'suppliers', exact: true, component: SuppliersLandingPage },
    { path: 'suppliers/search', exact: true, component: SuppliersSearch },
    { path: 'suppliers/savedsearches', exact: true, component: SavedSupplierSearchList },
    { path: 'suppliers/my-suppliers', exact: true, component: MySuppliersList },
    { path: 'suppliers/create', exact: true, component: CreateSupplier },
    { path: 'supplier/profile/:companyid/:locationid', exact: true, component: SupplierProfile },
    { path: 'supplier/:supplierId', exact: true, component: SupplierDetails },
        
    { path: 'apps/contacts/contact-cards', exact: true, component: ContactCards },
    { path: 'apps/contacts/edit-contact', exact: true, component: EditContact },

    { path: 'apps/file-manager/list-view', exact: true, component: ListView },
    { path: 'apps/file-manager/grid-view', exact: true, component: GridView },

    //Pages
    { path: 'pages/profile', exact: true, component: Profile },
    { path: 'pages/edit-profile', exact: true, component: EditProfile },
    { path: 'pages/account', exact: true, component: Account },
    { path: 'mycompany/account', exact: true, component: CompanyAccount },
    // { path: 'pages/company-account', exact: true, component: CompanyAccount },
    
    //Error
    { path: 'ErrorNoAccessToken', exact: true, component: ErrorNoAccessToken },
    { path: 'ErrorUnauthorized', exact: true, component: ErrorUnauthorized },
    { path: 'ErrorForbidden', exact: true, component: ErrorForbidden },
    { path: 'ErrorServerError', exact: true, component: ErrorServerError },
    { path: 'ErrorConflict', exact: true, component: ErrorConflict },
    { path: 'ErrorExpectationFailed', exact: true, component: ErrorExpectationFailed },
    { path: 'ErrorMethodNotAllowed', exact: true, component: ErrorMethodNotAllowed },
    { path: 'ErrorUnprocessableEntity', exact: true, component: ErrorUnprocessableEntity },
    { path: 'error-404', exact: true, component: Error404 },

    //Pages for STATUS and TESTING
    // OBSOLETE { path: 'view-B', exact: true, component: viewB },
    { path: 'health', exact: true, component: health },
    { path: 'ErrorAccountNotConfigured', exact: true, component: ErrorAccountNotConfigured },
    { path: 'sanity', exact: true, component: SavedOpportunitySearchListFORM },
    { path: 'test', exact: true, component: TestView },
    { path: 'test/icons', exact: true, component: TestIcons },
    { path: 'test/geo', exact: true, component: GeolocationExample },
    { path: 'test/map', exact: true, component: MapLeafletExamplePage },
    { path: 'test/supplierscore', exact: true, component: SupplierScore },
    { path: 'test/api-endpoint', exact: true, component: ApiEndpointTest },
    { path: 'test/supplier-to-item', exact: true, component: SupplierToItemTest },
    { path: 'test/supplier-requirements', exact: true, component: SupplierRequirementsTest },
    { path: 'test/documents', exact: true, component: DocumentTestView },

]

// Note: Unprotected routes are defined directly in App.jsx.
// Example: /health.

// export const authRoutes = [
//     { path: '/login', exact: true, component: Login },
//     { path: '/login-simple', exact: true, component: LoginSimple },
//     { path: '/login-classic', exact: true, component: LoginClassic },
//     { path: '/signup', exact: true, component: Signup },
//     { path: '/signup-simple', exact: true, component: SignUpSimple },
//     { path: '/signup-classic', exact: true, component: SignupClassic },
//     { path: '/lock-screen', exact: true, component: LockScreen },
//     { path: '/reset-password', exact: true, component: ResetPassword },
//     { path: '/error-503', exact: true, component: Error503 },
// ]